import { LKDate } from 'loankeeper-common/helpers/Date'

export const getDateInstance = (dateString) => LKDate.from(dateString).instance
export const toDateString = (dateString) => LKDate.from(dateString).toString()
export const getDateDiff = (dateString1, dateString2, unit) => {
  const date1 = getDateInstance(dateString1)
  const date2 = getDateInstance(dateString2)

  return date1.diff(date2, unit)
}
